import PropTypes from 'prop-types'
import {StyledPopover, StyledPopoverContent, StyledTableCell} from './LongTableCellStyle'
import {useCallback, useEffect, useRef, useState} from 'react'

const LongTableCell = ({children, onMouseEnter, onFocus, ...props}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [isOverflowing, setIsOverflowing] = useState(false)

  const cellRef = useRef(null)

  const updateOverflowState = useCallback(() => {
    const cellElement = cellRef.current

    if (!cellElement) {
      setIsOverflowing(false)
      return
    }

    setIsOverflowing(cellElement.scrollWidth > cellElement.clientWidth)
  }, [])

  const handlePopoverFocus = (event) => {
    updateOverflowState()
    if (onFocus) {
      onFocus(event)
    }
  }

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const openPopover = Boolean(anchorEl)

  useEffect(() => {
    updateOverflowState()
  }, [updateOverflowState, children])

  return (
    <>
      {isOverflowing && (
        <StyledPopover
          id='table-cell-popover'
          open={openPopover}
          anchorEl={anchorEl}
          slotProps={{paper: {role: 'tooltip'}}}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <StyledPopoverContent>{children}</StyledPopoverContent>
        </StyledPopover>
      )}
      <StyledTableCell
        ref={cellRef}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        onFocus={handlePopoverFocus}
        aria-haspopup={isOverflowing ? 'true' : undefined}
        aria-owns={openPopover ? 'table-cell-popover' : undefined}
        {...props}
      >
        {children}
      </StyledTableCell>
    </>
  )
}

LongTableCell.propTypes = {
  children: PropTypes.node.isRequired,
  onMouseEnter: PropTypes.func,
  onFocus: PropTypes.func
}

export default LongTableCell
